import React, { memo, useMemo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import SectionTitle from '../SectionTitle/SectionTitle';
import { SectionTitleAlignment } from '../../interfaces/enums/SectionTitleAlignment';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import { StoryblokNode } from '../../interfaces/StoryblokNode.interface';
import ContactInformation, {
  ContactInformationContentProps,
} from './ContactInformation';
import classNames from 'classnames';
import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer';

export interface ContactBarBlokProps extends Blok {
  subtitle?: string;
  title?: string;
  body?: StoryblokRichtext;
  contact_information?: StoryblokNode<ContactInformationContentProps>[];
}

interface ContactBarProps {
  blok: ContactBarBlokProps;
}

const ContactBar: React.FC<ContactBarProps> = ({
  blok: { subtitle, title, body, contact_information },
}) => {
  const isSectionTitleRequired: boolean = useMemo(() => {
    if (!subtitle && !title && !body) return false;
    return true;
  }, [subtitle, title, body]);

  return (
    <section
      className={classNames('pb-16 space-y-16 sm:pb-24 lg:pb-28 xl:pb-32', {
        'pt-12 sm:pt-16 lg:pt-20 xl:pt-28': !isSectionTitleRequired,
      })}
    >
      {isSectionTitleRequired && (
        <SectionTitle
          subtitle={subtitle}
          title={title}
          body={body}
          alignment={SectionTitleAlignment.Centre}
        />
      )}
      {contact_information && (
        <Container>
          <Grid>
            {contact_information.map(
              (
                info: StoryblokNode<ContactInformationContentProps>,
                index: number
              ) => (
                <ContactInformation
                  key={`${info._uid}${index}`}
                  info={info}
                  index_of_contact_information_item={index}
                  number_of_contact_information_items={
                    contact_information.length
                  }
                />
              )
            )}
          </Grid>
        </Container>
      )}
    </section>
  );
};

ContactBar.defaultProps = {
  blok: {
    subtitle: undefined,
    title: undefined,
    body: undefined,
    contact_information: [],
    component: 'contact',
    _editable: '',
    _uid: '',
  },
};

export default memo(withBlokWrapper(ContactBar, Theme.ALT));
